const DASHBOARD_NAME_UPDATED = (state, name) => {
  state.name = name;
};

const SET_ACTIVE_NOTE_COLLAPSE_PANELS = (context, arrayOfActivePanels) => {
  context.activeNoteCollapsePanels = arrayOfActivePanels;
};

const INITIALISE_STORE = (state, activeNoteCollapsePanels) => {
  const storeKey = "customer-dashboard-note-active-collapse-panels";

  if (localStorage.getItem(storeKey) !== null && Array.isArray(localStorage.getItem(storeKey))) {
    state.activeNoteCollapsePanels = JSON.parse(localStorage.getItem(storeKey));
  } else {
    state.activeNoteCollapsePanels = activeNoteCollapsePanels;
  }
};

export default {
  DASHBOARD_NAME_UPDATED,
  SET_ACTIVE_NOTE_COLLAPSE_PANELS,
  INITIALISE_STORE,
};
